// extracted by mini-css-extract-plugin
export default {"container":"most-least-pair_container__h515T","fieldset":"most-least-pair_fieldset__GJZf6","legend":"most-least-pair_legend__bkT29"};